import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-[#a3a8a4]" data-testid="auth-loading">
        Chargement...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (role === "client" && user.role !== "client") return <Navigate to="/admin" replace />;
  return children;
}
